import * as React from "react";
import * as ReactDOM from "react-dom";
import Component from "../../AbstractComponent";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import TextField from "../../Partials/Material/TextField";
import IconButton from '@material-ui/core/IconButton';

import Search from "../../../API/Search";
import * as onClickOutside from "react-onclickoutside";
import Time from "../../../Time/Time";

class Searchbar extends Component {
  protected config;

  public state = {
    results: [],
    searchText: "",
    width: "256px",
    display: "none",
    cursor: -1,
    clickStarted: false,
    selectedEntity: null,
    noScrollAgain: false
  };

  private fieldAmount: number = this.props.objectField ? 5 : 8;
  public ref = null;

  constructor(public props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onClick = this.onClick.bind(this);
    // this.onFocus = this.onFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  public componentWillMount(): any {
    this.setState({
      searchText: !!this.props.searchText ? this.props.searchText : "",
      selectedEntity: !!this.props.selectedEntity && this.props.selectedEntity
    });
  }

  public componentWillReceiveProps(nextProps): any {
    if (typeof nextProps.selectedEntity !== "undefined" &&
      nextProps.selectedEntity?.id !== this.props.selectedEntity?.id) {
      this.setState({
        searchText: !!nextProps.searchText ? nextProps.searchText : !!nextProps.selectedEntity ? `${nextProps.selectedEntity.nameOfEntity}, ${nextProps.selectedEntity.displayName}` : ""
      });
    }

    this.setState({
      selectedEntity: !!nextProps.selectedEntity && nextProps.selectedEntity
    }, () => {
      if (this.state.selectedEntity) {
        this.onBlur();
      }
    });
  }

  public componentWillUnmount = () => {
    this.setState({
      noScrollAgain: false
    })
  }

  protected onFocus = (event) => {
    event.preventDefault();

    if (this.state.selectedEntity || this.state.searchText) {
      return
    }

    Search.search(event.currentTarget.value, this.props.objectField, this.props.searchParameter).then(results => {
      let filteredResults = results;
      if (typeof this.props.filterResults === "function") {
        filteredResults = this.props.filterResults.apply(this, [results]);
      }
      this.setState({
        results: filteredResults
      }, () => {
        if (this.props.objectField && !this.props.withoutScroll) {
          this.setState({
            display: "block"
          }, () => {
            const element = ReactDOM.findDOMNode(this) as any;
            const elementPosition = element.getBoundingClientRect().top;
            const lookupComponentHeight = 420;
            if ((window.innerHeight - elementPosition) < lookupComponentHeight) {
              if (!this.state.noScrollAgain) {
                if (this.props.scrollToEndOfPage) {
                  document.documentElement.style.height = "calc(100% + 650px)";
                  var scrollingElement = (document.scrollingElement || document.body);
                  scrollingElement.scrollTop = scrollingElement.scrollHeight;
                } else {
                  if (window.innerHeight > elementPosition + lookupComponentHeight) {
                    window.scrollTo({
                      top: elementPosition + 200,
                      behavior: "smooth"
                    });
                  }
                }

                this.setState({
                  noScrollAgain: true
                });
              } else {
                return;
              }
            }
          });
        }
      })
    });
  }

  protected onChange(property: string, event: any) {
    this.setState({
      [property]: event.currentTarget.value,
      display: event.currentTarget.value.length === 0 && !this.state.selectedEntity ? "none" : "block",
      clickStarted: false
    });

    Search.search(event.currentTarget.value, this.props.objectField, this.props.searchParameter).then(results => {
      let filteredResults = results;
      if (typeof this.props.filterResults === "function") {
        filteredResults = this.props.filterResults.apply(this, [results]);
      }
      this.setState({
        results: filteredResults
      })
    });

    if (event.currentTarget.value.length === 0) {
      this.onClear();
    }
  }

  protected onClear() {
    this.setState({
      searchText: "",
      display: "none",
    }, () => {
      if (this.props.onClear) {
        this.props.onClear.call(this);
      }

      if (this.props.objectField === true) {
        // Quick fix for showing dropdown after clicking X button.
        setTimeout(() => {
          this.ref?.focus?.();
        }, 50);
      };
    });
  }

  public handleClickOutside(): void {
    if (this.props.objectField === true) {
      this.setState({
        display: "none",
      });
      return;
    }

    this.onClear();
  }

  public showFields(fieldsNumber: number): any {
    const { cursor } = this.state;

    // if (typeof this.props.allResults !== "undefined") {
    //   fieldsNumber = this.state.results.length;
    // }

    if (this.state.results.slice(0, fieldsNumber).filter(entity => !!entity && !!entity.instance && !!entity.instance.nameOfEntity).length === 0 && !this.state.selectedEntity) {
      return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50px", fontSize: "14px", color: "black" }}><span>{this.trans("dropdown-chargeobject-notfound")}</span></div>
    } else {
      return this.state.results.slice(0, fieldsNumber).filter(entity => !!entity && !!entity.instance && !!entity.instance.nameOfEntity).map((entity: any, index: number) => {
        return (
          <ListItem
            className={`${cursor === index ? "lookup-result active" : "lookup-result"}`}
            onMouseDown={this.onClick.bind(this, entity)}
            key={`search-result-${entity.instance.nameOfEntity.toLowerCase()}-${entity.instance.id}`}
          >
            <ListItemAvatar>
              <Avatar className="avatar">
                {entity && entity.instance.renderAvatar()}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <div
                    style={{
                      color: "#373636f2",
                      fontWeight: "bold", //entity.instance && entity.instance.nameForUrl === "property" ? "normal" (keeping incase)
                      fontSize: "14px",
                      marginTop: "2px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >{`${(entity.instance && entity.instance.nameForUrl === "unit" && entity.instance.type ? this.trans(entity.instance.type.label) + " - " : "") + entity.name}`}</div>
                  <div className="search-bar-entity-name">
                    {`${this.trans(`${entity.instance.labelForEntity}`)}${entity.instance.nameOfEntity === this.trans("contract") ? ", " + Time.formatOrNull(entity.instance.firstDate) : ""}`}
                  </div>
                </div>
              }
            />
          </ListItem>
        );
      });
    }
  }

  public setClickStarted = () => {
    this.setState({ clickStarted: true });
  }

  public onBlur = () => {
    if (!this.state.clickStarted) {
      setTimeout(() => {
        if (this.state.selectedEntity) {
          this.setState({
            display: "none",
            results: [],
            clickStarted: false,
            searchText: this.state.searchText ? this.state.searchText : !!this.state.selectedEntity ? `${this.state.selectedEntity.nameOfEntity}, ${this.state.selectedEntity.displayName}` : ""
          });
        } else {
          this.setState({
            display: "none",
            results: [],
            clickStarted: false,
            searchText: ""
          });
        }
      }, 100);

      if (typeof this.props.onBlur !== "undefined") {
        setTimeout(() => {
          this.props.onBlur.call(this);
        }, 100);
      }
    }
  }

  public onClick(res: any): any {
    if (this.props.objectField === true) {
      this.setState({
        display: "none",
        searchText: res.name,
        clickStarted: false
      });

      this.props.onChange.call(this, res.instance);
      return;
    } else {
      this.onClear();

      return this.redirect(res.url);
    }
  }

  public handleKeyDown(e) {
    const { cursor } = this.state;
    const maxCursor = Math.min(this.fieldAmount, this.state.results.length) - 1;

    if (e.keyCode === 38 && cursor > 0) {
      // arrow up
      this.setState({ cursor: cursor - 1 });
    } else if (e.keyCode === 40 && cursor < maxCursor) {
      // arrow down
      this.setState({ cursor: cursor + 1 });
    } else if (e.keyCode === 27) {
      // esc
      this.onClear();
    } else if (e.keyCode === 13 && cursor > -1) {
      // enter
      this.onClick(this.state.results[cursor]);
    }
  }

  public redirectToCreatePage = (): void => {
    if (this.props.saveDetailsBeforeRedirect) {
      this.props.saveDetailsBeforeRedirect();
    }

    return this.redirect(this.props.createButton);
  }

  public render() {
    let floatingLabelText = "";
    let linkedObjectUrl;
    let fieldsNumber;
    let isAgencySelected = false;

    if (this.props.objectField && !this.props.floatingLabelText) {
      floatingLabelText = this.trans("object");
    }

    if (this.props.objectField && this.props.floatingLabelText) {
      floatingLabelText = this.props.floatingLabelText;
    }

    if (this.state.selectedEntity) {
      let nameForUrl = this.state.selectedEntity && this.state.selectedEntity.nameForUrl && this.state.selectedEntity.nameForUrl.toLowerCase();

      if (nameForUrl === "event") {
        if (this.state.selectedEntity && this.state.selectedEntity.eventTypeId && this.state.selectedEntity.eventTypeId === 34) {
          nameForUrl = "activity";
        }
      }
      if (this.state.selectedEntity.nameOfEntity === "Activity") {
        nameForUrl = this.state.selectedEntity.nameOfEntity.toLowerCase();
      } else {
        nameForUrl = this.state.selectedEntity.nameForUrl
      }

      linkedObjectUrl = `/app/${nameForUrl}/update/${this.state.selectedEntity.id}`
    }

    // we should not show link icon if agency selected
    if (this.state.selectedEntity?.nameForUrl === "company" &&
      this.state.selectedEntity?.id === this.props.app?.session?.user?.agencyId) {
      isAgencySelected = true;
    }

    if (typeof this.props.allResults !== "undefined") {
      fieldsNumber = this.state.results.length;
    }

    return (
      <div
        id="search-bar"
        className={!this.props.objectField ? "search-bar main-searchbar" : "search-bar like-component"}
      >
        <div className="clear-button-container">
          <TextField
            autoComplete="off"
            id={this.props.id}
            name={this.props.name}
            className={!!this.props.objectField ? `form-element ${!!this.props.className ? this.props.className : ""}` : ""}
            inputProps={{ ref: input => this.ref = input }}
            type="text"
            onFocus={this.onFocus}
            onChange={this.onChange.bind(this, "searchText")}
            value={this.props.searchText || this.state.searchText}
            label={floatingLabelText}
            autoFocus={this.props.autoFocus}
            onBlur={this.onBlur.bind(this)}
            disabled={this.props.disabled}
            variant="standard"
            globalSearch={!this.props.objectField}
            style={{ paddingLeft: "15px !important" }}
            error={!!this.props.error}
            onKeyDown={this.handleKeyDown}
            placeholder={!this.props.objectField ? this.trans("generalsearch-label") : ""}
            inputRef={this.props.inputRef}
          />
          {!!this.props.error && <div className="component-error-text">{this.props.error}</div>}
          {this.state.searchText && this.state.searchText.length > 0 && !this.props.disabled && (
            <div className="icon icon-ic-close clear-button" onClick={this.onClear}></div>
          )}

          {this.state.selectedEntity && linkedObjectUrl && !isAgencySelected && this.props.showClickThroughLink && (
            <IconButton className="icon-button-wrapper" style={{ position: "absolute", right: "-42px", top: "22px", cursor: "pointer" }}>
              <div
                className="icon icon-ic-open-in-new" onClick={() => this.redirect(linkedObjectUrl)}
              >
              </div>
            </IconButton>
          )}
        </div>

        <div style={{
          display: this.state.display,
          width: this.state.width,
          overflow: "auto",
          height: (this.state.results.slice(0, fieldsNumber).filter(entity => !!entity && !!entity.instance && !!entity.instance.nameOfEntity).length === 0) ? "auto" : this.props.height ? `${this.props.height}px` : "auto"
        }}
          className={`lookup-result-container ${this.props.className} ${this.props.styleInModal ? this.props.styleInModal : ""}`}>
          {this.showFields(this.fieldAmount)}
          {
            this.props.createButton && (
              <ListItem
                className={"lookup-result-button-wrapper new-tenant"}
                onMouseDown={() => {
                  if (this.props.openCoachCreateNewEntity) {
                    this.props.openCoachCreateNewEntity();
                  }
                }}
              >
                <ListItemText
                  primary={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="search-bar-entity-name">
                        {this.trans(this.props.createButton)}
                      </div>
                    </div>
                  }
                />
              </ListItem>
            )
          }
        </div>
      </div>
    );
  }
}

export default onClickOutside(Searchbar);
